export enum ProgressVariants {
  error = 'error',
  info = 'info',
  success = 'success',
}
